'use strict';

function getButtonGroup(buttons) {
  return {
    tag: 'div',
    attrs: {
      className: {
        'btn-group': true
      }
    },
    children: buttons
  };
};

module.exports = getButtonGroup;




//////////////////
// WEBPACK FOOTER
// ./~/tcomb-form/~/uvdom-bootstrap/lib/getButtonGroup.js
// module id = 651
// module chunks = 0